import React from 'react';
import {View} from 'react-native';

import {STAGGER} from '../constants';
import type {BoneRowProps} from '../types';

import {Bone} from './Bone';

export const BoneRow: React.FC<BoneRowProps> = React.memo(
  ({leftWidth = 0.4, rightWidth = 0.3, height = 12, animationDelay = 0, style}) => (
    <View
      style={[
        {flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'},
        style,
      ]}>
      <Bone
        width={`${Math.round(leftWidth * 100)}%`}
        height={height}
        borderRadius={2}
        animationDelay={animationDelay}
      />
      <Bone
        width={`${Math.round(rightWidth * 100)}%`}
        height={height}
        borderRadius={2}
        animationDelay={animationDelay + STAGGER.interval}
      />
    </View>
  ),
);

BoneRow.displayName = 'BoneRow';
